"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var React = require("react");

var zIndex_1 = require("../../../systems/zIndex");

var MobileNavDOM = styled_components_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  background-color: #444;\n  top: 55px;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  transition: .3s all ease-in;\n  z-index: ", ";\n  &.hidden {\n    display: none;\n  }\n"], ["\n  position: fixed;\n  background-color: #444;\n  top: 55px;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  transition: .3s all ease-in;\n  z-index: ", ";\n  &.hidden {\n    display: none;\n  }\n"])), zIndex_1.default.Header);

var MobileNav = function MobileNav(props) {
  return React.createElement(MobileNavDOM, {
    id: "mobile-navigation",
    className: "hidden"
  }, props.children);
};

exports.default = MobileNav;
var templateObject_1;